export default __webpack_public_path__ + "static/media/Landing_page_feature_3.500ef46f.png";